
import Breadcrumb from "./Breadcrumb.vue";
export default {
  props: ["title", "route", "route2", "title2"],
  name: "PageHeader",
  components: { Breadcrumb },
};
